import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
// import { getDashboardCount } from "../redux/actions/DashboardActions";
import { Row, Col, Card, Button, InputGroup, Form, Spinner } from "react-bootstrap";
import PageTitle from "../../Components/PageTitle";
import { useTranslation } from "react-i18next";
import { saveVehicleData } from "../../redux/actions/VehicleActions";
import FormInput from "../../Components/FormInput";
import { useNavigate, useParams } from "react-router-dom";
import { logout } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import Select from "react-dropdown-select";
import swal from 'sweetalert2';
import { MapContainer, Marker, Popup, TileLayer, useMap } from 'react-leaflet'
import HyperDatepicker from "../../Components/Datepicker";
import { getAllUsertypeUserList, getHydrantList, getMasterBlockBookingList, getMasterDestinationList, getMasterHydrantList, getMasterSarpanchBookingList, getMasterSettings } from "../../redux/actions/MasterActions";
import { getHydrantListById } from "../../redux/actions/HydrantActions";
import { getDateTimeMysqlGivenFormatYmdhi } from "../../util/generalUtills";
import { getDestinationList, getDestinationListById } from "../../redux/actions/DestinationActions";
import { generateSlipData, getSlipAllotmentListById, saveBookingData } from "../../redux/actions/BookingActions";
import LeafletMap from "../../Components/LeafletMap";
import Preloader from "../../Components/Preloader";


const GenerateSlip = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    tanker_number: 1,
    no_of_tanker: 1,
    hydrantLat: 0.00,
    hydrantLng: 0.00,
    destinationLat: 0.00,
    destinationLng: 0.00,
    bookingDate: new Date(),
    totalDistance: 0
  })
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth, loading, errors },
    masterReducer: {
      loadingMaster,
      errorsMaster,
      masterSettingsLists,
      masterHydrantLists,
      masterDestinationLists,
      masterSarpanchBookingLists,
      masterBlockBookingLists,
      masterUsertypeUserLists,
    },
    hydrantReducer: {
      hydrantLists,
      loadingHydrant
    },
    destinationReducer: {
      destinationLists,
      loadingDestination,
    },
    bookingReducer: {
      slipAllotmentList,
      changedBookingStatus,
      loadingBooking,
      errorsBooking,
    },
    userReducer: {
      userLists,
      loadingUser,
      errorsUser,
      changedUserStatus,
    },
  } = useSelector((state) => state);

  const [validated, setValidated] = useState(false);
    const [fieldErrors, setFieldErrors] = useState({});
  

  useEffect(() => {
    if (auth?.accessToken) {
      dispatch(getSlipAllotmentListById(auth?.accessToken, id));
      dispatch(getMasterSettings(auth?.accessToken));
      //dispatch(getAllUsertypeUserList(auth?.accessToken, 13,''));
    }

  }, [auth?.accessToken]);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
    swal.fire({
      title: "Confirmation ?",
      text: `Total distance you have entered is ${formData.totalDistance}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#28bb4b",
      cancelButtonColor: "#f34e4e",
      confirmButtonText: "Confirm my booking!",
    }) 
      .then((result) => {
        if (result.isConfirmed) {
          const payload={
             jenId:formData?.jen?.jenId,
      slipGenerationId: formData?.slipGenerationId ,
      hydrantName: formData?.hydrantName,
      hydrantLat: formData?.hydrantLat,
      hydrantLng: formData?.hydrantLng,
      name:formData?.name,
      mobile:formData?.mobile,
      destinationName: formData?.destinationName,
      destinationLat: formData?.destinationLat,
      destinationLng: formData?.destinationLng,
      totalDistance: formData?.totalDistance, 
      approval_one: formData?.approval_one ,    
      approval_two: formData?.approval_two ,
      booking_type:formData?.booking_type,
      

      vehicleType: 'Tanker',
          }
        
          dispatch(generateSlipData(auth?.accessToken, payload));
        }
      });

  };

  useEffect(() => {
    if (errors) {
      if (errors?.status == 401) {
        dispatch(logout())
        toast.error(errors?.data?.message);
        window.location.reload();
      }
    }

  }, [errors])

  useEffect(() => {
    if (errorsBooking?.status == 409) {
      swal.fire({
        show: true,
        title: "Oops!",
        text: errorsBooking?.data?.message,
        icon: "error",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: 'RESET_DELETE_STATUS' });
    }
   else if (errorsBooking?.status == 400) {


        if (errorsBooking?.data?.errors && Array.isArray(errorsBooking.data.errors)) {
          const transformedErrors = {};
          errorsBooking.data.errors.forEach(error => {
            if (error.field && error.message) {
              transformedErrors[error.field] = error.message;
            }
          });
          setFieldErrors(transformedErrors);
        }else{
      dispatch({ type: 'RESET_DELETE_STATUS' });
        }
      }
  }, [errorsBooking])

  const inputHandler = (e) => {
    const { value, name } = e.target
    setFormData({ ...formData, [name]: value });
 if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      }
    );
    }
  }

  const inputHandlerNumeric = (e) => {
    const { value, name } = e.target;
    // Replace all non-numeric characters except the first dot
    const processedValue = value
      .replace(/[^\d.]/g, '')          // Remove all non-numeric and non-dot characters
      .replace(/^(\d*\.?)|(\d*)\./g, '$1$2'); // Remove any additional dots

    setFormData({ ...formData, [name]: processedValue });
  };


  // const inputHandlerMobile = (e) => {
  //   const { value, name } = e.target;
  //   let processedValue = value.replace(/\D/g, '');
  //   if (processedValue.length > 10) {
  //     processedValue = processedValue.slice(0, 10);
  //   }
  //   const isValidMobileNumber = /^([56789]\d{9})$/.test(processedValue);
  //   if (isValidMobileNumber) {
  //     setFormData({ ...formData, [name]: processedValue });
  //   }
  // };

  const inputHandlerMobile = (e) => {
    const { value, name } = e.target;
    if (/^\d{0,10}$/.test(value)) {
      setFormData(prevFormData => ({
        ...prevFormData,
        [name]: value,
      }));
    }
 if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      }
    );
    }

  };



  const inputHandlerCaps = (e) => {
    const { value, name } = e.target;
    const processedValue = value.replace(/\s+/g, '').toUpperCase(); // Remove spaces and convert to uppercase
    setFormData({ ...formData, [name]: processedValue });

  };

  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      jenId:slipAllotmentList?.jen?.id,
      slipGenerationId: slipAllotmentList?.id ?? ' ',
      hydrantName: slipAllotmentList?.hydrant?.name ?? ' ',
      hydrantLat: slipAllotmentList?.hydrant?.lat ?? '0.00',
      hydrantLng: slipAllotmentList?.hydrant?.lng ?? '0.00',
      name:slipAllotmentList?.customer?.name,
      mobile:slipAllotmentList?.customer?.mobileNumber,
      altNumber: slipAllotmentList?.altNumber,
      destinationId: slipAllotmentList?.destination?.id,
      destinationName: slipAllotmentList?.destination?.name ?? ' ',
      destinationLat: slipAllotmentList?.destination?.lat ?? '0.00',
      destinationLng: slipAllotmentList?.destination?.lng ?? '0.00',
      totalDistance: slipAllotmentList?.totalDistance, 
      approval_one: slipAllotmentList?.approval_one ,    
      approval_two: slipAllotmentList?.approvaltwo ,
      booking_type:slipAllotmentList?.bookingType,
      

      vehicleType: 'Tanker',
    }));
    if(slipAllotmentList?.jen?.id) {
      dispatch(getMasterHydrantList(auth?.accessToken, slipAllotmentList?.jen?.id));
      dispatch(getMasterDestinationList(auth?.accessToken, slipAllotmentList?.jen?.id));
    }
    dispatch(getMasterBlockBookingList(auth?.accessToken));
    dispatch(getMasterSarpanchBookingList(auth?.accessToken));
  }, [slipAllotmentList])

  const selectHandler = (selectedData, name) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: selectedData
    }));

  };

  useEffect(() => {
    if (changedBookingStatus.success) {
      swal.fire({
        show: true,
        title: "Well done!",
        text: changedBookingStatus.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: 'RESET_DELETE_STATUS' });
      navigate(-1);
    }
  }, [changedBookingStatus])

  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errorsBooking?.data?.vehicle_model ? 'red' : base.borderColor,
      '&:hover': {
        borderColor: errorsBooking?.data?.vehicle_model ? 'red' : base.borderColor,
      }
    }),
  };

  const onDateChange = (name, value) => {
    if (value) {
      setFormData({ ...formData, [name]: value });
    }
  };

  useEffect(() => {
    setFormData({});
    dispatch({ type: 'RESET_DELETE_BOOKING_STATUS' });
  }, [dispatch]);

  useEffect(() => {
    //generateTankerOptions(masterSettingsLists.no_of_tanker)
  }, [masterSettingsLists])

  const generateTankerOptions = (noOfTankers) => {
    const options = [];
    for (let i = 1; i <= noOfTankers; i++) {
      options.push({ value: `${i}`, label: `${i} Tanker` });
    }
    return options;
  };

  useEffect(() => {
    dispatch(getHydrantListById(auth?.accessToken, formData?.hydrantId))
  }, [formData?.hydrantId])

  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      hydrantName: hydrantLists?.name ?? ' ',
      hydrantLat: hydrantLists?.lat ?? '0.00',
      hydrantLng: hydrantLists?.lng ?? '0.00',
      vehicleType: 'Tanker',
    }));

  }, [hydrantLists])

  useEffect(() => {
    dispatch(getDestinationListById(auth?.accessToken, formData?.destinationId))
  }, [formData?.destinationId])

  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      destinationName: destinationLists?.name ?? ' ',
      destinationLat: destinationLists?.latitude ?? '0.00',
      destinationLng: destinationLists?.longitude ?? '0.00'
    }));
  }, [destinationLists])


  useEffect(() => {
  }, [formData])
  //

  /*
   * handle form submission
   */


  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: t("Generate Slip"), path: "Generate-Slip" },
          { label: t("Generate Slip"), path: "/Generate-Slip", active: true },
        ]}
        title={t("Generate Slip")}
      />
      <Row>
        <Col lg={6}>
          <Card>
            <Card.Body>
              <div style={{ position: "relative", overflow: "hidden", height: "450px" }}>
                <LeafletMap
                  mapHeight={"450px"}
                  center={[formData.hydrantLat, formData.hydrantLng]}
                  zoom={15}
                  hydrantMarkerPosition={[formData.hydrantLat, formData.hydrantLng]}
                  destinationMarkerPosition={[formData.destinationLat, formData.destinationLng]}
                  setFormData={setFormData}
                />
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={6}>
          <Card>
            <Card.Body>
              {errorsBooking?.data?.message && (
                <div className="alert alert-danger">
                  {errorsBooking.data.message}
                </div>
              )}
              <Row>
                <Col lg={6}>
                  <FormInput
                    label={t("Customer Mobile")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.mobile}
                    name="mobile"
                    onChange={inputHandlerMobile}
                    containerClass={"mb-3"}
                  />
                </Col>
                <Col lg={6}>
                  <FormInput
                    label={t("Customer Name")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.name}
                    name="name"
                    onChange={inputHandler}
                    containerClass={"mb-3"}
                  />
                </Col>
                <Col lg={6}>
                  <FormInput
                    label={t("Alt Number")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.altNumber}
                    name="altNumber"
                    onChange={inputHandlerMobile}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("Booking Type")}</Form.Label>
                    <Select
                      classNamePrefix="react-select"
                      name="booking_type"
                      values={formData.booking_type ? [{ value: formData.booking_type, label: formData.booking_type }] : []}
                      options={[
                        { value: "Emergency", label: "Emergency" },
                        { value: "Regular", label: "Regular" },
                      ]}
                      onChange={(selectedData) => selectHandler(selectedData[0]?.value, "booking_type")}
                      styles={customSelectStyles}
                    />
                    {fieldErrors?.booking_type && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{fieldErrors.booking_type}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <FormInput
                    label={t("Hydrant")}
                    type="text"
                    disabled={true}
                    errors={fieldErrors}
                    value={formData.hydrantName}
                    name="hydrantName"
                    onChange={inputHandlerMobile}
                    containerClass={"mb-3"}
                  />
                </Col>
                <Col lg={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("Destination")}</Form.Label>
                    <Select
                      classNamePrefix="react-select"
                      name="destinationId"
                      values={formData.destinationId && masterDestinationLists?.length > 0 
                        ? masterDestinationLists.filter(item => item.destinationId === formData.destinationId)
                        : []}
                      options={masterDestinationLists}
                      valueField={"destinationId"}
                      labelField={"name"}
                      onChange={(selectedData) => selectHandler(selectedData[0]?.destinationId, "destinationId")}
                      styles={customSelectStyles}
                    />
                    {fieldErrors?.destinationId && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{fieldErrors.destinationId}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>
                <Col lg={3}>
                  <FormInput
                    label={t("Hydrant Lat")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.hydrantLat}
                    name="hydrantLat"
                    containerClass={"mb-3"}
                  />
                </Col>
                <Col lg={3}>
                  <FormInput
                    label={t("Hydrant Lng")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.hydrantLng}
                    name="hydrantLng"
                    containerClass={"mb-3"}
                  />
                </Col>
                <Col lg={3}>
                  <FormInput
                    label={t("Destination Lat")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.destinationLat}
                    name="destinationLat"

                    containerClass={"mb-3"}
                  />
                </Col>
                <Col lg={3}>
                  <FormInput
                    label={t("Destination Lng")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.destinationLng}
                    name="destinationLng"

                    containerClass={"mb-3"}
                  />
                </Col>
                <Col lg={4}>
                  <FormInput
                    label={t("Distance")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.totalDistance}
                    name="totalDistance"
                    onChange={inputHandlerNumeric}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("Approval One")}</Form.Label>
                    <Select
                      classNamePrefix="react-select"
                      name="approval_one"
                      values={formData?.approval_one && masterSarpanchBookingLists?.length > 0
                        ? masterSarpanchBookingLists.filter(item => item.id === formData.approval_one)
                        : []}
                      options={masterSarpanchBookingLists}
                      valueField={"id"}
                      labelField={"name"}
                      onChange={(selectedData) => selectHandler(selectedData[0]?.id, "approval_one")}
                      styles={customSelectStyles}
                    />
                    {fieldErrors?.approval_one && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{fieldErrors.approval_one}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("Approval Two")}</Form.Label>
                    <Select
                      classNamePrefix="react-select"
                      name="approval_two"
                      values={formData?.approval_two && masterBlockBookingLists?.length > 0
                        ? masterBlockBookingLists.filter(item => item.id === formData.approval_two)
                        : []}
                      options={masterBlockBookingLists}
                      valueField={"id"}
                      labelField={"name"}
                      onChange={(selectedData) => selectHandler(selectedData[0]?.id, "approval_two")}
                      styles={customSelectStyles}
                    />
                    {fieldErrors?.approval_two && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{fieldErrors.approval_two}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>
              </Row>

              {loading ?
                <>
                  <Button color="primary" disabled>
                    <Spinner
                      className="spinner-border-sm me-1"
                      tag="span"
                      color="white"
                    />
                    Please wait ...
                  </Button>
                </>
                :
                <>
                  <Button type="button" onClick={handleSubmit} disabled={loading}>
                    Submit
                  </Button>
                </>
              }


            </Card.Body>
          </Card>
        </Col>
      </Row>
      {loadingBooking && (<Preloader />)}
      {loadingDestination && (<Preloader />)}
      {loadingMaster && (<Preloader />)}
      {loadingUser && (<Preloader />)}
      {loadingHydrant && (<Preloader />)}

    </>
  );
};

export default GenerateSlip;
